import React from 'react';
import { useRouter } from 'next/router';
import camelCase from 'lodash/camelCase';
import { Box, Button, Text } from '@sparknz/spark-pattern-library';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { InfoLayerStatus, WearablePlans } from 'journey/productDetails/typings';
import { useAuthorableContents } from 'shared/providers/AuthorableContentsProvider/AuthorableContentsProvider';
import { getPlanCategory } from 'shared/utils';

const EligibilityCheckInformation = () => {
  const router = useRouter();

  const { getText, getLink } = useAuthorableContents();

  const { dispatch, planOffers, selectedDevice } = useProductDetails();

  const handleClick = (contentKey: string) => {
    dispatch({
      type: ProductDetailsActionTypes.SetInfoLayer,
      infoLayer: {
        contentKey,
        status: InfoLayerStatus.ContentFragment,
        isNested: false,
      },
    });
  };

  // Once Samsung wearable go live successfully in production, need to replace default return jsx code with if statement's code.
  // Also need to ask content author to remove unwanted content from product details' content(journey-id: online-shop/product-details). ex. productDetails.eligibility.header

  const category = getPlanCategory({
    routePlanId: router.query.planId,
    planOffers,
  });

  const planCategory = camelCase(
    WearablePlans[selectedDevice?.brand as keyof typeof WearablePlans],
  );

  const showTitle2 = category.includes(WearablePlans.Apple);

  return (
    <Box mb="s5">
      <Text mb="s2" variant="bodyMDemi">
        {getText(`productDetails.eligibility.${planCategory}.header`)}
      </Text>
      <Text mb="s1" variant="bodySMedium">
        {getText(`productDetails.eligibility.${planCategory}.title1`)}&nbsp;
        <Button
          variant="textbutton"
          onClick={() =>
            handleClick(
              getLink(`productDetails.eligibility.${planCategory}.link`),
            )
          }
        >
          {getText(`productDetails.eligibility.${planCategory}.link`)}
        </Button>
      </Text>
      {showTitle2 ? (
        <Text mb={['s4', 's6']} variant="bodySMedium">
          {getText(`productDetails.eligibility.${planCategory}.title2`)}
        </Text>
      ) : null}
    </Box>
  );
};

export default EligibilityCheckInformation;
